var module = angular.module('octopusApp.infrastructure');

module.directive("octoSection", function(octoUtil, $compile, $rootScope) {
    return {
        restrict: 'AC',
        link: function(scope, element, attr) {
            var sectionName = "section" + attr.octoSection;
            var scopedDomInstances = [];

            function update(){
                var placeholder = $rootScope[sectionName];
                if (placeholder) {
                    scopedDomInstances = $compile(element.html())(scope);
                    _.forEach(scopedDomInstances, function(a) { placeholder.appendChild(a); });
                }
            }

            var stateChangeDetach = $rootScope.$on('$stateChangeSuccess', function() {
                update();
            });

            scope.$on('$destroy', function() {
                var placeholder = $rootScope[sectionName];
                if (placeholder) {
                    _.forEach(scopedDomInstances, function(a) { placeholder.removeChild(a); });
                }
                stateChangeDetach();
            });

            update();


            /*
            var sectionName = "section" + attr.octoSection;
            function update(){
                var placeholder = $rootScope[sectionName];
                if (placeholder) {
                    var templateHtml = element.html();
                    var scopedDomInstance = $compile(templateHtml)(scope);
                    $(placeholder).html(scopedDomInstance);
                }
                //  console.log('Updaging '+ attr.octoSection);
            }
            var stateChangeDetach = $rootScope.$on('$stateChangeSuccess', function(e, a, b) {
                console.log("Section State: "+ attr.octoSection);
                update();
            });

            var sectionWatchDetach = $rootScope.$watch(sectionName, function(){
                console.log("Section Watch: "+ attr.octoSection);
                update();
            });

            scope.$on('$destroy', function() {
                console.log("Section Destroy: "+ attr.octoSection);
                stateChangeDetach();
                sectionWatchDetach();
            });
*/
            /*


            var changer1 = $rootScope.$watch("section" + attr.octoSection, update);


            function update(){
                var placeholder = $rootScope["section" + attr.octoSection];
                if (placeholder) {
                    var templateHtml = element.html();
                    var scopedDomInstance = $compile(templateHtml)(scope);
                    $(placeholder).html(scopedDomInstance);
                }
              //  console.log('Updaging '+ attr.octoSection);
            }

            var changer2 = $rootScope.$on('$stateChangeSuccess', function(e, a, b) {
                update();
            });

            scope.$on('$destroy', function() {
                //stop watching when scope is destroyed
                //console.log("Detatching Section"+ attr.octoSection);
                changer2();
                changer1();
            });*/
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/directives/octo_section.js
// module id = 679
// module chunks = 1